import { getUserBrowserData } from '@automation-suite/shared-clients-user-browser-store';

import { type LoggerTransformation } from '@automation-suite/shared-clients-logger';

declare global {
  interface Window {
    FS: {
      getCurrentSessionURL(): string;
      identify: (userId: string, traits: Record<string, unknown>, source?: string) => void;
      setUserVars: (traits: Record<string, unknown>, source?: string) => void;
      event: (eventName: string, eventData?: Record<string, unknown>, source?: string) => void;
    };
  }
}

export const withUserBrowserContext: LoggerTransformation = (report) => {
  const identity = getUserBrowserData();
  return {
    ...report,
    context: {
      ...report.context,
      userBrowserId: identity.browserId,
      sessionId: identity.sessionId,
      fullstorySessionUrl: window.FS?.getCurrentSessionURL?.(),
    },
  };
};
